import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { useIsTaxWithholdingTabAvailable } from '@mews-commander/modules/src/modules/accountingConfiguration';
import { GuideLinkButton, PageLayout, useBreadcrumbs, useTabs } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { compactArray } from '@mews/fp';

export const Layout = () => {
    const breadcrumbs = useBreadcrumbs();

    const isTaxWithholdingPageEnabled = useIsTaxWithholdingTabAvailable();

    const tabs = useTabs(
        '/$currentEnterpriseId/Settings/AccountingConfiguration',
        compactArray(['Detail', 'AccountingCategories', isTaxWithholdingPageEnabled ? 'TaxWithholding' : null])
    );

    const actions = <GuideLinkButton guideLink={createGuideLink(ArticlePath.WhatIsAccountingConfiguration)} />;

    return (
        <PageLayout padded breadcrumbs={breadcrumbs} tabs={tabs} actions={actions}>
            <Outlet />
        </PageLayout>
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/AccountingConfiguration')({
    component: () => <Layout />,
    staticData: {
        owner: MewsTeam.Accounting,
        title: TextKey.AccountingConfiguration,
        type: RouteType.Frontend,
    },
});
